export const FETCH_LOGIN_LOGS_REQUEST = 'FETCH_LOGIN_LOGS_REQUEST';
export const FETCH_LOGIN_LOGS_SUCCESS = 'FETCH_LOGIN_LOGS_SUCCESS';
export const FETCH_LOGIN_LOGS_FAILURE = 'FETCH_LOGIN_LOGS_FAILURE'; 